import { parseDate } from "@utils/dateUtils";

import { ImageElement } from "@/types";

export interface EventCardData {
  id?: string;
  title: string;
  description: string;
  image?: ImageElement;
  slug: string;
  eventDate: string;
  eventLocaltion: string;
}

export function sanitizeEventCardData(pageTypeItem: any): EventCardData {
  const hero = pageTypeItem?.components?.[0];
  const eventDescriptionSection = pageTypeItem?.components?.[1];

  return {
    id: pageTypeItem?.id,
    title: pageTypeItem?.listCardTitle ?? hero?.title ?? pageTypeItem?.internalName ?? "",
    description: pageTypeItem?.cardDescription ?? eventDescriptionSection?.description?.html ?? eventDescriptionSection?.description ?? "",
    image: pageTypeItem?.thumbnail ?? hero?.image ?? hero?.imageMobile ?? undefined,
    slug: pageTypeItem?.slug ?? "",
    eventDate: hero?.eventDate ?? "",
    eventLocaltion: hero?.eventLocaltion ?? "",
  };
}

// An event with no/unparsable eventDate is treated as not expired so it still shows under "Active".
export function isEventExpired(eventDate?: string): boolean {
  if (!eventDate) return false;
  const date = parseDate(eventDate);
  if (isNaN(date.getTime())) return false;
  return date.getTime() < Date.now();
}
